import { Button, Dialog, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import StyledCardTitleBar from '../../common/StyledCardTitleBar';
import StyledDialogActions from '../../common/StyledDialogActions';
import SextforceCaptionsManager from './SextforceCaptionsManager';

type Props = {
    open: boolean;
    onClose: () => void;
};

export default function SextforceCaptionsDialog(props: Props) {
    const { open, onClose } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile} disableEscapeKeyDown>
            <StyledCardTitleBar title="Manage Captions" isLoading={isLoading} />
            <DialogContent
                sx={{
                    px: { xs: 1.5, sm: 2 },
                    pt: 1,
                    pb: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    height: { xs: 'calc(100dvh - 120px)', sm: 'auto' },
                    overflow: 'hidden',
                }}
            >
                <SextforceCaptionsManager inDialog onLoadingChange={setIsLoading} />
            </DialogContent>
            <StyledDialogActions>
                <Button variant="contained" color="secondary" onClick={onClose}>
                    Close
                </Button>
            </StyledDialogActions>
        </Dialog>
    );
}
